function mapModule() {
    const mapElement = document.getElementById('map');

    if (!mapElement) {
        return;
    }

    const lat = mapElement.getAttribute('data-lat');
    const long = mapElement.getAttribute('data-long');
    const zoom = mapElement.getAttribute('data-zoom');

    const parseAttribute = (attrName) => {
        const rawValue = mapElement.getAttribute(attrName);

        if (!rawValue) {
            return [];
        }

        try {
            const parsedValue = JSON.parse(rawValue);

            return Array.isArray(parsedValue) ? parsedValue : [];
        } catch (error) {
            console.warn(`mapModule: failed to parse ${attrName}`, error);

            return [];
        }
    };

    const markers = parseAttribute('data-markers');
    const markersNao = parseAttribute('data-markers-extra');

    const map = L.map('map', {
        scrollWheelZoom: false,
        touchZoom: false,
        zoomControl: true
    })
        .setView([parseFloat(lat), parseFloat(long)], parseFloat(zoom))
        .addLayer(
            L.tileLayer(
                'https://api.mapbox.com/styles/v1/mapbox/light-v9/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiY2FwcmktbGFuZGluZyIsImEiOiJjbWZwYnVzcWQwZHd4MmpzODJhbGsxeHhqIn0.HuBQ2R4mk-845Jp2YgKPVw',
                {
                    maxZoom: 16,
                    minZoom: 12,
                    tileSize: 512,
                    zoomOffset: -1,
                    attribution: '© <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                }
            )
        );

    const mainMarker = L.icon({
        iconUrl: themeData.iconPath1,
        iconSize: [40, 40],
    });

    const dotMarker = L.icon({
        iconUrl: themeData.iconPath3,
        iconSize: [25, 25],
    });

    const extraMarker = L.icon({
        iconUrl: themeData.iconPath3,
        iconSize: [25, 25],
    });

    L.marker([parseFloat(lat), parseFloat(long)], { icon: mainMarker }).bindTooltip("Mixtura Coworking", {
        permanent: true,
        direction: 'bottom',
        offset: [0, 20],
        className: 'map__marker-label'
    }).addTo(map);

    if (Array.isArray(markers)) {
        markers.forEach(marker => {
            L.marker([parseFloat(marker.coord.lat), parseFloat(marker.coord.long)], { icon: dotMarker })
                .bindTooltip(marker.texto || "Location", {
                    permanent: false,
                    direction: 'bottom',
                    offset: [0, 3],
                    className: 'map__marker-label'
                })
                .addTo(map);
        });
    }

    if (Array.isArray(markersNao)) {
        markersNao.forEach(marker => {
            L.marker([parseFloat(marker.coord.lat), parseFloat(marker.coord.long)], { icon: extraMarker })
                .bindTooltip(marker.texto || "Location", {
                    permanent: true,
                    direction: 'bottom',
                    offset: [0, 3],
                    className: 'map__marker-label'
                })
                .addTo(map);
        });
    }
}

export default mapModule;